











import { Component, Vue } from "vue-property-decorator";
import NavMenu from "@/components/NavMenu.vue"; // @ is an alias to /src
import { authManager } from "@/utils/login";
import { User } from "@/models/user";
import { UserService } from "@/services/user-service";
import { defineRulesFor } from "@/services/abilities-service";

@Component({
  components: {
    NavMenu,
  },
})
export default class App extends Vue {
  user: User = new User();
  userService: UserService = new UserService();

  mounted() {
    authManager
      .getUser()
      .then((ssoUser) => {
        if (ssoUser !== null) {
          console.log("User loaded:", ssoUser.profile.name);
          return ssoUser;
        } else {
          console.log("Not signed in.");
        }
      })
      .then((authUser) => {
        if (authUser != null) {
          this.userService.getMe().then((redankaUser) => {
            this.user = redankaUser;
            if (this.user != null) {
              this.user.logged_in = true;
              this.user.redanka_roles = authUser.profile.roles;
              console.log("Redanka user:", JSON.stringify(this.user));
              this.$ability.update(defineRulesFor(this.user));
            }
          });
        }
      })
      .catch((error) => {
        console.log("Error in getting user:", error.message);
      });
  }
}
